import GameEditForm from "./game-edit-form";

const GameForms = { Edit: GameEditForm };

export default GameForms;
